import { initMicrofrontend } from '../initMicrofrontend';

import { createContext } from '../../createContext';
import { createAppState, IAppState } from '../../../../shared/AppModulesWrapper';

export function runAppV2() {
  const context = createContext({ isMicrofrontend: true });

  const initialState = context.config.getStrict<IAppState>('initialState');
  const store = createAppState(context, initialState);

  initMicrofrontend({ ...context, store });
}
